
<script>
  import { Column } from 'bastone';
  export let title = '';
</script>


<svelte:head>
  <title>{title} - Deeppp新一代AI技术驱动IM-BOT平台,自定义BOT,私有数据集BOT</title>
</svelte:head>


<Column height=100vh width=100% xAlign=center>
  <slot></slot>
</Column>
